import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const notificationsList = createAsyncThunk('notifications/list', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `notification_list`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        });
        return res;
    } catch (error) {
        return error.response;
    }
});

const notificationsSlice = createSlice({
    name: 'notifications',
    initialState: {
        list: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(notificationsList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });
    }
});

export default notificationsSlice.reducer;